export const numberToStars = (n: number) => <sup>{'*'.repeat(n)}</sup>;
